import { type Action, createAction } from '@reduxjs/toolkit';

import {
  ERequestFailedActionType,
  type IRequestFailedPayload,
  type RequestFailedAction,
} from '../../../admin-types';

export const requestFailed = createAction<IRequestFailedPayload>(
  ERequestFailedActionType.REQUEST_FAILED,
);

export const isRequestFailed = (
  action: Action | null | undefined,
): action is RequestFailedAction =>
  Boolean(action) && requestFailed.match(action as Action);
